<fuse-loading-bar [autoMode]="false"></fuse-loading-bar>
<router-outlet></router-outlet>
